import React, { useContext, useState, Fragment } from "react";
import { AlignCenter } from "react-feather";
import { Link, useNavigate } from "react-router-dom";
import { Image } from "../../AbstractElements";
import CheckContext from "../../_helper/Customizer";
import Logo from "../../assets/images/logo/logo.svg";
import { connect } from "react-redux";
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const Leftbar = (props) => {
  const { mixLayout, toggleSidebar, toggleIcon } = useContext(CheckContext);
  const [toggle, setToggle] = useState(false);
  const history = useNavigate();
  const openCloseSidebar = () => {
    setToggle(!toggle);
    toggleSidebar(toggle);
  };
  const clearProject = () => {
    const { dispatch } = props;
    dispatch({
      type: "settings/CHANGE_SETTING",
      payload: {
        setting: "project",
        value: null,
      },
    });
    dispatch({
      type: "settings/CHANGE_SETTING",
      payload: {
        setting: "projectSelected",
        value: false,
      },
    });
    history(`app/project/project-list`);
  };
  return (
    <Fragment>
      <div
        style={{ width: "230px", paddingTop: 0, paddingBottom: 0 }}
        className="main-header-left"
      >
        {mixLayout ? (
          <div
            className="logo-wrapper"
            onClick={() => clearProject()}
            style={{ cursor: "pointer" }}
          >
            <img
              className="img-fluid d-inline"
              style={{ height: 50, objectFit: "contain" }}
              src={props?.settings?.organisation?.organisation_logo ?? Logo}
            />
          </div>
        ) : (
          <div className="dark-logo-wrapper">
            <Link to={`/app/project/project-list`}>
              <Image
                attrImage={{
                  className: "img-fluid d-inline",
                  src:
                    props?.settings?.organisation?.organisation_logo ??
                    `${require("../../assets/images/logo/dark-logo.png")}`,
                  alt: "",
                }}
              />
            </Link>
          </div>
        )}
        <div className="toggle-sidebar" onClick={() => openCloseSidebar()}>
          <AlignCenter className="status_toggle middle" id="sidebar-toggle" />
        </div>
      </div>
    </Fragment>
  );
};

export default connect(mapStateToProps)(Leftbar);
